export var images = {
    icnTickLarge: require("./files/icn_tickLarge.svg"),
};
